import { useCallback, useMemo } from 'react'
import {
  useActiveAccount,
  useActiveWallet,
  useAutoConnect,
  useConnectModal,
  useDisconnect
} from 'thirdweb/react'
import { inAppWallet } from 'thirdweb/wallets'
import { thirdwebClient as client } from 'app/thread'
import useLogger from 'lib/util/useLogger'

const debug = useLogger('Use Thirdweb', '#CD5C5C')

/**
 * The `useThirdweb` hook
 *
 * @returns {object} the context object
 */
function useThirdweb () {
  const { data: autoConnected } = useAutoConnect({
    client
  })
  const { connect, isConnecting } = useConnectModal()
  const { disconnect } = useDisconnect()
  const account = useActiveAccount()
  const wallet = useActiveWallet()

  debug.log({
    'isConnecting: ': isConnecting,
    'account: ': account,
    'autoConnected: ': autoConnected
  })

  /**
   * Get account
   */
  const getAccountThirdweb = async () => {
    let userInfo = null

    try {
      userInfo = account

      debug.log('getAccountThirdweb() => userInfo', userInfo)
    } catch (e) {
      console.error('Unable to get user', e)
    }

    return userInfo
  }

  /**
   * Connect
   */
  const connectThirdweb = useCallback(async () => {
    try {
      const wallet = await connect({
        client,
        showAllWallets: false,
        wallets: [inAppWallet()]
      })

      const autoConnect = await wallet.autoConnect({ client })

      debug.log('connectThirdweb() => wallet', wallet, autoConnect)

      return wallet
    } catch (e) {
      console.error(e)
      // User closed modal
    }
  }, [])

  /**
   * Disconnect
   *
   * @returns {void}
   */
  const disconnectThirdweb = () => disconnect(wallet)

  const ctx = useMemo(
    () => ({
      connectThirdweb,
      disconnectThirdweb,
      getAccountThirdweb
    }),
    [connectThirdweb, disconnectThirdweb, getAccountThirdweb]
  )

  return ctx
}

// Export
export default useThirdweb
